import { useAtom } from "jotai";
import type { CSSProperties } from "react";

import { ModalDialog } from "@skilitics/designer-ui-components";

import { tutorialsStateAtom } from "./applicationSettingsAtoms";
import { TutorialContents } from "./TutorialContents";
import { useTutorialData, type TutorialArea } from "./useTutorialData";

type Props = {
  area: TutorialArea;
};

export const Tutorial = ({ area }: Props) => {
  // Disable tutorials when run from automation tools such as Playwright.
  if (navigator.webdriver) return null;
  return <TutorialDialog area={area} />;
};

const TutorialDialog = ({ area }: Props) => {
  const [tutorialsState, setTutorialsState] = useAtom(tutorialsStateAtom);
  const { data: tutorialData, isLoading } = useTutorialData();

  const onClose = () => {
    setTutorialsState((prev) => ({
      ...prev,
      [area]: false,
    }));
  };

  // Fail quietly if unable to load tutorial info. This isn't critical to the application.
  if (
    !tutorialsState[area] ||
    isLoading ||
    !tutorialData ||
    !(area in tutorialData) ||
    !Array.isArray(tutorialData[area])
  )
    return null;

  return (
    <ModalDialog
      open
      onClose={onClose}
      onClick={(e) => e.stopPropagation()}
      slotProps={{ paper: { style: modalStyle } }}
    >
      <TutorialContents tutorialContents={tutorialData[area]} onClose={onClose} />
    </ModalDialog>
  );
};

const modalStyle: CSSProperties = {
  width: 860,
  maxWidth: "90vw",
  height: 520,
  borderRadius: "12px",
  overflow: "hidden",
};
